var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close-Icon",
    d: "M0.201878 0.201878C-0.0672776 0.471033 -0.0673074 0.907458 0.201878 1.17664L7.02523 8L0.201878 14.8234C-0.0672776 15.0925 -0.0673074 15.5289 0.201878 15.7981C0.471062 16.0673 0.907488 16.0673 1.17664 15.7981L8 8.97477L14.8234 15.7981C15.0925 16.0673 15.529 16.0673 15.7981 15.7981C16.0673 15.529 16.0673 15.0925 15.7981 14.8234L8.97477 8L15.7981 1.17664C16.0673 0.907488 16.0673 0.471062 15.7981 0.201878C15.5289 -0.0673074 15.0925 -0.0672776 14.8234 0.201878L8 7.02523L1.17664 0.201878C0.907458 -0.0673074 0.471033 -0.0672776 0.201878 0.201878Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/Close-Icon.48bcb6689918c5d05e7513c68258ceff.svg";
export { ForwardRef as ReactComponent };